"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ContainerService = /** @class */ (function () {
    function ContainerService(container, serviceCreationCallback) {
        this.container = container;
        this.serviceCreationCallback = serviceCreationCallback;
    }
    ContainerService.prototype.get = function () {
        if (this.serviceInstance) {
            return this.serviceInstance;
        }
        this.serviceInstance = this.serviceCreationCallback(this.container);
        return this.serviceInstance;
    };
    ContainerService.prototype.raw = function () {
        return this.serviceCreationCallback;
    };
    return ContainerService;
}());
exports.ContainerService = ContainerService;
var FactoryContainerService = /** @class */ (function (_super) {
    __extends(FactoryContainerService, _super);
    function FactoryContainerService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FactoryContainerService.prototype.get = function () {
        return this.serviceCreationCallback(this.container);
    };
    return FactoryContainerService;
}(ContainerService));
exports.FactoryContainerService = FactoryContainerService;
var ProtectedParameter = /** @class */ (function (_super) {
    __extends(ProtectedParameter, _super);
    function ProtectedParameter(container, serviceCreationCallback) {
        var _this = _super.call(this, container, serviceCreationCallback) || this;
        _this.container = container;
        _this.serviceCreationCallback = serviceCreationCallback;
        _this.value = _this.serviceCreationCallback(_this.container);
        return _this;
    }
    ProtectedParameter.prototype.get = function () {
        return this.value;
    };
    return ProtectedParameter;
}(ContainerService));
exports.ProtectedParameter = ProtectedParameter;
var Container = /** @class */ (function () {
    function Container() {
        this.registry = new Map();
    }
    Container.prototype.register = function (service, serviceCreationCallback) {
        var _this = this;
        if (service && typeof service === 'string') {
            this.throwIfServiceAlreadyRegistered(service);
            this.throwIfServiceCreationCallbackNotSupplied(serviceCreationCallback);
            if (serviceCreationCallback instanceof FactoryContainerService) {
                this.registry.set(service, serviceCreationCallback);
            }
            else if (serviceCreationCallback instanceof ProtectedParameter) {
                this.throwIfParameterAlreadyRegistered(service);
                Object.assign(this, (_a = {},
                    Object.defineProperty(_a, service, {
                        get: function () {
                            return serviceCreationCallback.get();
                        },
                        enumerable: true,
                        configurable: true
                    }),
                    _a));
            }
            else {
                this.registry.set(service, new ContainerService(this, serviceCreationCallback));
            }
        }
        else if (service instanceof Container) {
            service.registry.forEach(function (value, key) {
                _this.register(key, value.raw());
            });
        }
        else {
            this.throwIfInvalidServiceType();
        }
        return this;
        var _a;
    };
    Container.prototype.factory = function (serviceCreationCallback) {
        return new FactoryContainerService(this, serviceCreationCallback);
    };
    Container.prototype.protect = function (parameterCreationCallback) {
        return new ProtectedParameter(this, parameterCreationCallback);
    };
    Container.prototype.get = function (service) {
        this.throwIfNotInRegistry(service);
        return this.registry.get(service).get();
    };
    Container.prototype.extend = function (service, extensionCallback) {
        this.throwIfNotInRegistry(service);
        var serviceMethod = this.get(service);
        extensionCallback(serviceMethod, this);
    };
    Container.prototype.raw = function (service) {
        this.throwIfNotInRegistry(service);
        return this.registry.get(service).raw();
    };
    Container.prototype.delete = function (service) {
        if (this.registry.has(service)) {
            this.registry.delete(service);
        }
    };
    Container.prototype.deleteAll = function () {
        this.registry.clear();
    };
    Container.prototype.throwIfServiceAlreadyRegistered = function (service) {
        if (this.registry.has(service)) {
            throw new Error(service + " has already been registered, user unique service name");
        }
    };
    Container.prototype.throwIfParameterAlreadyRegistered = function (parameter) {
        if (this.hasOwnProperty(parameter)) {
            throw new Error(parameter + " has already been registered, user unique parameter name");
        }
    };
    Container.prototype.throwIfServiceCreationCallbackNotSupplied = function (callback) {
        if (!callback) {
            throw new Error("callback must be supplied when registering a service or protected parameter");
        }
    };
    Container.prototype.throwIfNotInRegistry = function (service) {
        if (!this.registry.has(service)) {
            throw new Error(service + " not in registry");
        }
    };
    Container.prototype.throwIfInvalidServiceType = function () {
        throw new Error("service must be of type string or Container");
    };
    return Container;
}());
exports.Container = Container;
//# sourceMappingURL=hypo.js.map